"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReferralType = void 0;
let ReferralType = exports.ReferralType = /*#__PURE__*/function (ReferralType) {
  ReferralType["None"] = "None";
  ReferralType["PBS"] = "PBS";
  ReferralType["ECREF"] = "ECREF";
  return ReferralType;
}({});
